var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as store from 'store';
import { server, spinner } from '../common/conf';
import C from '../common/C';
import './login.css';
import { Auth } from './auth';
// 8414d8684dee702ed738e25798868a8b969ece43
export function logout() {
    store.set('login-dp-token', null);
    return fetch(server + "logout");
}
var jwtCheckPromise = window.jwtCheckPromise;
if (!jwtCheckPromise) {
    jwtCheckPromise = fetch(server + 'jwt');
}
var loginPromise;
export function login() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!loginPromise)
                loginPromise = doLogin();
            return [2 /*return*/, loginPromise];
        });
    });
}
export function user_login() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/];
        });
    });
}
export function doLogin() {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                    function check(token) {
                        return fetch(server + 'login', {
                            method: 'POST',
                            body: JSON.stringify({ token: token }),
                        })
                            .then(function (x) { return x.json(); })
                            .then(function (x) {
                            if (x.status != 'ok')
                                throw x.reason;
                            if (!isResolved) {
                                isResolved = true;
                                body.remove();
                                resolve(new Auth(x));
                                return true;
                            }
                            return false;
                        })
                            .catch(function (e) {
                            return false;
                        });
                    }
                    function init() {
                        div.html("\n        <input class='token' placeholder='token' id='login-token'></input><button type='submit' id='login-submit'>Submit</button>\n        <div style='text-align: center;margin-top: 10px;'>\n        Please enter the token your got from \n        <a href='https://aqicn.org/data-platform/token/' target=\"_dp\">aqicn.org/data-platform/</a>\n        </div>");
                        var input = document.getElementById('login-token');
                        input.onkeydown = function (key) {
                            if (key.keyCode == 13) {
                                store.set('login-dp-token', { token: input.value });
                            }
                        };
                        var submit = document.getElementById('login-submit');
                        submit.addEventListener('click', function () {
                            div.html(spinner + '<br>Checking your token ' + input.value);
                            check(input.value)
                                .then(function (success) {
                                if (success) {
                                    store.set('login-dp-token', { token: input.value });
                                }
                                else {
                                    init();
                                }
                            })
                                .catch(function (e) {
                                div.html("            \n            <input class='token' placeholder='enter your token' id='login-token'></input><button type='submit' id='login-submit'>Submit</button>\n            <div style='text-align: center;margin-top: 10px;'>\n            Sorry, something went wrong: ".concat(e, "\n            </div>"));
                            });
                        });
                    }
                    var isResolved, body, div, value;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                isResolved = false;
                                body = new C(document.body).c('div', 'login-container');
                                // document.body.insertBefore(body.node(), document.body.firstChild);
                                jwtCheckPromise
                                    .then(function (x) { return x.json(); })
                                    .then(function (x) {
                                    if (isResolved)
                                        return;
                                    if (x.status == 'ok') {
                                        isResolved = true;
                                        body.hide();
                                        resolve(new Auth(x));
                                    }
                                });
                                div = body.c('div', 'login-inner').c('div', 'login');
                                value = store.get('login-dp-token');
                                if (!value) return [3 /*break*/, 2];
                                div.html(spinner + '<br>Checking your token');
                                return [4 /*yield*/, check(value.token)];
                            case 1:
                                if (_a.sent()) {
                                    return [2 /*return*/];
                                }
                                else {
                                    init();
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                init();
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); })];
        });
    });
}
